import query from '@/components/query/query-constructor';

export const pushURL = (ctx: any, cb?: Function) => {
  if (ctx.$route.name !== 'app.conversions' || !ctx.$store.getters.savedColumnsInCurentPreset)
    return;

  const { columns, order, context } = ctx.$store.getters.savedColumnsInCurentPreset.conversions;

  const {
    from,
    to,
    timezone,
    date,
    compareFrom,
    compareTo,
    compareDate,
    compareEnabled,
    currency,
    limit,
    offset,
  } = ctx.$store.getters.tableQueryForCurrentTab;

  const data = query.get({
    from,
    to,
    timezone,
    date,
    compareFrom,
    compareTo,
    compareDate,
    compareEnabled,
    currency,
    limit,
    offset: offset[context],
    ...order,
    columns,
    groupBy: context,
  });

  ctx.$router.replace({
    name: 'app.conversions',
    params: {
      data: data,
      report: ctx.$route.params.report,
      manual: true,
      picker: true
    }
  }, cb, cb);
};
